import api from "api";
import React, {  useEffect } from "react";
import { connect } from 'react-redux';
import stateMap from "store/stateMap";
import { SetInitiative, SetInitiativeAccess } from "store/dispatcher";
import "./style.scss";
import { useState } from "react";
import { format, parseISO, parse } from "date-fns";
import { useFormik } from "formik";
import store from "store/store";
import { Link } from "react-router-dom";
import RoleJoinButton, { RolesUpdateRole, RoleTotalRequiredElement } from "component/RoleJoinButton";

import {  useNavigate } from "react-router-dom";
import _ from "lodash";
import { GetInitiativeStatusName, GetInitiativeStatusDesc, SetInitiativeStatus } from "component/Initiative";
import {  AvatarVertical1 } from "component/Avatar";
import { createBrowserHistory, parsePath } from "history";
import { PageCredential } from "component/PageCredential";

import { GetInitiativeStatusLabel } from "component/Initiative";


const AboutResearch = (props) => {
    return (
        props.initiative && props.initiative.InitiativeType === "research" && props.initiative.ResearchType &&
        <div className="initiative-about-metas">
            <dl>
                {props.initiative.TargetProduct && <>
                    <dt>Research Output</dt>
                    <dd>
                    {_.last(
                        store.getState().config.ResearchOutput[
                            _.indexOf(_.map(store.getState().config.ResearchOutput, 0), props.initiative.TargetProduct )
                        ] || []
                    )}
                    </dd>
                </>}
                {props.initiative.ResearchType && <>
                    <dt>Research Type</dt>
                    <dd>
                    {_.last(
                        store.getState().config.ResearchType[
                            _.indexOf(_.map(store.getState().config.ResearchType, 0), props.initiative.ResearchType )
                        ] || []
                    )}</dd>
                </>}
                {props.initiative.ResearchLength && <>
                    <dt>Research Length</dt>
                    <dd>{props.initiative.ResearchLength} Year(s)</dd>
                </>}
                {props.initiative.KnowledgeFieldName && <>
                    <dt>Field of Science By QS Subject</dt>
                    <dd dangerouslySetInnerHTML={{__html : props.initiative.KnowledgeFieldName}}></dd>
                </>}
                {props.initiative.ResearchFieldName && <>
                    <dt>Research Field</dt>
                    <dd>{props.initiative.ResearchFieldName}</dd>
                </>}
                {props.initiative.ImpactName && <>
                    <dt>Socio-Economic Goals</dt>
                    <dd>{props.initiative.ImpactName}</dd>
                </>}
                {props.initiative.Funding && <>
                    <dt>Expected Funding</dt>
                    <dd>{props.initiative.Funding}</dd>
                </>}
                {props.initiative.Funding && props.initiative.FundingSource && <>
                    <dt>Funding Source</dt>
                    <dd>{props.initiative.FundingSource}</dd>
                </>}
                {props.initiative.Funding && props.initiative.FundingInst && <>
                    <dt>Funding Institution</dt>
                    <dd>{props.initiative.FundingInst}</dd>
                </>}
            </dl>
        </div>
    )
}

const AboutEvent = (props) => {
    return (
        props.initiative && props.initiative.InitiativeType === "event" &&
        <div className="initiative-about-metas">
            <dl>
                {props.initiative.EventLookFor && props.initiative.EventTypes?.length > 0 && <>
                    <dt>Type</dt>
                    <dd>
                        {props.initiative.EventTypes[0].TypeName || 
                         (props.initiative.EventSelfDescribeType && `Other : ${props.initiative.EventSelfDescribeType}`)}
                    </dd>
                </>}
                
                {props.initiative.EventLookFor && props.initiative.Location && <>
                    <dt>Location</dt>
                    <dd>{props.initiative.Location}</dd>
                </>}

                {props.initiative.EventLookFor && props.initiative.CampusArea && <>
                    <dt>Campus</dt>
                    <dd>{_.last(
                        store.getState().config.campus[
                            _.indexOf(_.map(store.getState().config.campus, 0), props.initiative.CampusArea)
                        ] || []
                    )}</dd>
                </>}

                {props.initiative.EventLookFor && props.initiative.Organizer && <>
                    <dt>Organizer</dt>
                    <dd>{props.initiative.Organizer}</dd>
                </>}

                {props.initiative.EventLookFor && props.initiative.ScopeLevel && <>
                    <dt>Level</dt>
                    <dd>{_.last(
                        store.getState().config.EventLevel[
                            _.indexOf(_.map(store.getState().config.EventLevel, 0), props.initiative.ScopeLevel)
                        ] || []
                    )}</dd>
                </>}

                {props.initiative.EventLookFor && props.initiative.EventForms && <>
                    <dt>Held</dt>
                    <dd>{_.last(
                        store.getState().config.EventForms[
                            _.indexOf(_.map(store.getState().config.EventForms, 0), props.initiative.EventForms)
                        ] || []
                    )}</dd>
                </>}

                {props.initiative.Rundown && <>
                    <dt>Rundown</dt>
                    <dd>
                        <div className="wp-content" dangerouslySetInnerHTML={{__html: props.initiative.Rundown}}/>
                    </dd>
                </>}

                {(props.initiative.StartDate || props.initiative.EventStartTime || 
                  props.initiative.EndDate || props.initiative.EventEndTime) && <>
                    <dt>Event Time</dt>
                    <dd>
                        {props.initiative.StartDate && format(parseISO(props.initiative.StartDate, 'dd-LLLL-Y'), 'dd LLLL y')}
                        {props.initiative.EventStartTime && <>
                            &nbsp;{format(parse(props.initiative.EventStartTime, 'HH:mm:ss', new Date()), 'HH:00')}
                        </>}
                        
                        {(props.initiative.StartDate || props.initiative.EventStartTime) && 
                         (props.initiative.EndDate || props.initiative.EventEndTime) && 
                         <>&nbsp;-&nbsp;</>}

                        {props.initiative.EndDate && format(parseISO(props.initiative.EndDate, 'dd-LLLL-Y'), 'dd LLLL y')}
                        {props.initiative.EventEndTime && <>
                            &nbsp;{format(parse(props.initiative.EventEndTime, 'HH:mm:ss', new Date()), 'HH:00')}
                        </>}
                    </dd>
                </>}
            </dl>
        </div>
    )
}




export default connect( stateMap, {SetInitiative, SetInitiativeAccess} )((props) => {
    const queryString                           = new URLSearchParams(parsePath(window.location.href).search || '');
    const [InitiativeRoles, setInitiativeRoles] = useState(false);
    let history                                 = createBrowserHistory();
    const [coCreators, setCoCreators]           = useState([]);

    let navigate = useNavigate();

    const formik = useFormik({
        initialValues : props.initiative.initiative
        ,onSubmit : values => {
            if( props.initiative.access.membership && props.initiative.access.membership.MemberType === 'admin' )
            {
                SetInitiativeStatus(values.InitiativeID, values.CurrentStatus, props.auth.token)
                    .then(initiative => {
                        props.SetInitiative(initiative);
                    })
            }
        }
    })

    const GetInitiativeRoles = () => {
        api('/Role', 'get', {
            initiative_id : props.initiative.initiative.InitiativeID
        })
            .then((response) => {
                setInitiativeRoles(response.roles);
            });
    }

    const UpdateRole = (updatedAccess, updatedRole ) => {
        props.SetInitiativeAccess(updatedAccess);

        setInitiativeRoles(RolesUpdateRole(InitiativeRoles, updatedRole));
    }

    const GetCoCreator = () => {
        api('/CoCreator', 'get', {
            InitiativeID : props.initiative.initiative.InitiativeID
        }, 'Bearer ' + props.auth.token )
            .then(response => {
                setCoCreators(response.cocreator)
            })
    }

    useEffect(GetInitiativeRoles, [props.initiative.initiative]);
    useEffect(GetCoCreator, [props.initiative.initiative]);

    return (
        <div className="initiative-body-container container">
            <PageCredential title={props.initiative.initiative.Title} />
            <div className="initiative-body">
                
                <h2 className="initiative-body-title bold">About this initiative</h2>
                <AboutResearch initiative={props.initiative.initiative} />
                <AboutEvent initiative={props.initiative.initiative} />
                {
                    props.initiative.initiative.Description.length > 0 && 
                    <>
                        <hr/>
                        <div className="wp-content" dangerouslySetInnerHTML={{__html : props.initiative.initiative.Description}}/>
                    </>
                }
            </div>
            <div className="initiative-sidebar-boxes">
                <div className="mb-md">
                    <h2 className="initiative-body-title">Initiator</h2>
                    <div className="rounded border-solid sidebar-box text-center">
                        <div className="wrapper">
                            <AvatarVertical1 user={_.assignIn({}, props.initiative.initiative, {
                                UserID : props.initiative.initiative.InitiatorID
                            }) }/>
                        </div>
                    </div>
                </div>
                {

                    coCreators.length > 0 && 
                        <div className="mb-md">
                            <h2 className="initiative-body-title">Co-Manage</h2>
                        </div>
                
                }
                {
                    coCreators.length > 0 && coCreators.map((coCreator) => (
                        <div className="mb-md">
                            <div className="rounded border-solid sidebar-box text-center">
                                <div className="wrapper">
                                    <AvatarVertical1 user={coCreator}/>
                                </div>
                            </div>
                        </div>
                    ))
                }
                <div className="mb-md">
                    <h2 className="initiative-body-title">Status</h2>
                    <div className="rounded border-solid sidebar-box text-center">
                        {
                            props.initiative.initiative.PlatformSynced !== 'Bridge' &&
                            <div className="wrapper">
                                {       
                                    props.initiative.access.membership && props.initiative.access.membership.MemberType === 'admin' ?
                                    <form className="generic-form" onSubmit={formik.handleSubmit}>
                                        <div className="fancy-select">
                                            <select 
                                                onChange={formik.handleChange}
                                                value={formik.values.CurrentStatus}
                                                name="CurrentStatus"
                                            >
                                                <option value="">Select Status</option>
                                                <option value="recruitment">{ GetInitiativeStatusLabel(props.initiative.initiative, 'recruitment') }</option>
                                                <option value="work-in-progress">{ GetInitiativeStatusLabel(props.initiative.initiative, 'work-in-progress') }</option>
                                                <option value="rating">{ GetInitiativeStatusLabel(props.initiative.initiative, 'rating') }</option>
                                                <option value="completed">{ GetInitiativeStatusLabel(props.initiative.initiative, 'completed') }</option>
                                            </select>
                                        </div>
                                        <div className="text-right">
                                            <div className="leading-text text-sm text-right mt-sm mb-lg">
                                                {GetInitiativeStatusDesc(props.initiative.initiative.InitiativeType, formik.values.CurrentStatus)}
                                            </div>
                                            <button className="btn btn-orange btn-small">Update</button>
                                        </div> 
                                    </form>
                                    :
                                    <div className="">
                                        <div className="text-left font-bold">
                                            { GetInitiativeStatusName(props.initiative.initiative) }
                                        </div>
                                        <div className="leading-text text-xs text-left font-light mt-sm">
                                            { GetInitiativeStatusDesc(props.initiative.initiative.InitiativeType, props.initiative.initiative.CurrentStatus) }
                                        </div>
                                    </div>
                                }
                                {
                                    props.initiative.initiative.UpdateDate &&
                                    <>
                                        <hr />
                                        <div className="text-left mt-md">
                                            <span className="text-xs block mb-sm">Last Updated</span>
                                            <span className="block">{ format(parseISO(props.initiative.initiative.UpdateDate,'dd-LLLL-Y'), 'dd LLLL y') }</span>
                                        </div>
                                    </>
                                }
                            </div>
                        }
                        {
                            props.initiative.initiative.PlatformSynced === 'Bridge' &&
                            <div className="wrapper">
                                {       
                                    props.initiative.access.membership && props.initiative.access.membership.MemberType === 'admin' ?
                                    <div>
                                        <h4 className="font-semibold">Update @Bridge Apps</h4>
                                        <p className="leading-text">
                                            Go To BRIDGE Apps to update the status of this opportunity.
                                        </p>
                                    </div> 
                                    : 
                                    <div className="">
                                        <div className="text-left font-bold">
                                            {
                                                ['recruitment','work-in-progress'].indexOf(props.initiative.initiative.CurrentStatus) > -1 && <span>Active</span>
                                            }
                                            {
                                                ['rating'].indexOf(props.initiative.initiative.CurrentStatus) > -1 && <span>Rating</span>
                                            }
                                            {
                                                ['completed'].indexOf(props.initiative.initiative.CurrentStatus) > -1 && <span>Opportunity Completed</span>
                                            }
                                            {
                                                ['propose'].indexOf(props.initiative.initiative.CurrentStatus) > -1 && <span>Opportunity Being Reviewed</span>
                                            }
                                        </div>
                                    </div>
                                }

                            </div>
                        }
                    </div>
                </div>
                <div className="mb-md">
                    {
                        InitiativeRoles !== false && props.initiative.initiative.InitiativeType !== 'event' && 
                        <div className="">
                            <h2 className="initiative-body-title">Recruitment</h2>
                            {
                                InitiativeRoles && InitiativeRoles.map((InitiativeRole) => (
                                    <div className="rounded border-solid sidebar-box mb-md" key={InitiativeRole.RoleID}>
                                        <div className="wrapper">
                                            <span className="block box-title text-lg bold">{InitiativeRole.RoleName}</span>
                                            <div className="leading-text box-content">{InitiativeRole.RoleDesc}</div>
                                            <span className="recruitment-info text-center">
                                                <span className="block text-xs">Talent Joined</span>
                                                <div className="mt-sm">
                                                    <div className="text-sm">
                                                        <RoleTotalRequiredElement role={InitiativeRole}/>
                                                    </div>
                                                    {
                                                        props.initiative.access && (InitiativeRole.TotalRequired === 0 || InitiativeRole.TotalJoin < InitiativeRole.TotalRequired) && props.initiative.initiative.CurrentStatus === 'recruitment' &&
                                                        <div className="mt-md">
                                                            <RoleJoinButton 
                                                                className="btn-block mt-sm"
                                                                role={InitiativeRole} 
                                                                access={props.initiative.access}
                                                                onJoin={UpdateRole}
                                                                onLeave={UpdateRole}
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                ))
                            }
                            {
                                InitiativeRoles.length == 0 && props.initiative.access.membership && props.initiative.access.membership.MemberType === 'admin' &&
                                <span className="block leading-text text-sm">
                                    Hi, {props.auth.user.UserDisplayName} please create a role for your initiative so others can join
                                    <Link className="btn btn-orange btn-mini btn-reverse mt-md" to="member">Go to member page</Link>
                                </span>
                            }
                        </div>
                    }
                    {
                        InitiativeRoles === false && <span className="skeleton"></span>
                    }
                </div>
            </div>
            
        </div>
    );
});